import { Component, OnInit } from '@angular/core';
import { ColumnType, ABCisTableModel } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi, ApiService } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'store-config',
  standalone: false,
  templateUrl: './store-config.component.html'
})
export class StoreConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'store',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'storeId', header: 'Store ID', type: ColumnType.String , isReadonly: true, isPrimary: true, width: '80px'  },
        { field: 'storeName', header: 'Store Name', type: ColumnType.String },
        { field: 'documentPriority', header: 'Document Priority', type: ColumnType.String, width: '80px' },
        { field: 'allowNonOrderable', header: 'Allow Non Orderable', type: ColumnType.Boolean },
        { field: 'searchStoreDataBeforeGlobalData', header: 'Store Before Global', type: ColumnType.Boolean },
        { field: 'documentDateSetting', header: 'Document Date Setting', type: ColumnType.DropDown, setUrl: 'document-date/lookup' },
        { field: 'deliveryDateSetting', header: 'Delivery Date Setting', type: ColumnType.DropDown, setUrl: 'document-date/lookup' },
        { field: 'datesBeforeCurrentMonthSetting', header: 'Dates Before Current Month', type: ColumnType.DropDown, setUrl: 'dates-before-current-month/lookup' },
        { field: 'documentNumberStorePrefix', header: 'Doc No Store Prefix', type: ColumnType.String, width: '90px'},
        { field: 'documentNumberStoreSuffix', header: 'Doc No Store Suffix', type: ColumnType.String, width: '90px' },
        { field: 'documentNumberCreditPrefix', header: 'Doc No Credit Prefix', type: ColumnType.Boolean, width: '90px' },
        { field: 'documentNumberDocketPrefix', header: 'Doc No Docket Prefix', type: ColumnType.Boolean, width: '90px' },
        { field: 'documentNumberCaptureRegex', header: 'Doc No Capture Regex', type: ColumnType.String, width: '90px' },
        { field: 'documentNumberReplaceRegex', header: 'Doc No Replace Regex', type: ColumnType.String, width: '90px' },
        { field: 'productVarianceThreshold', header: 'Product Variance Threshold', type: ColumnType.String, width: '80px' },
        { field: 'underchargeIgnoreValue', header: 'Undercharge Ignore Value', type: ColumnType.String, width: '80px' }
      ],
      addFormConfig: {
        header: 'Add Store Configuration'
      },
      isConfigurable: true
    };
  }
}
